import { render, staticRenderFns } from "./getLog.vue?vue&type=template&id=288a66c6&"
import script from "./getLog.vue?vue&type=script&lang=js&"
export * from "./getLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports